export default __webpack_public_path__ + "search-examples-uitextfield-search-thumbnail-960-098b2a88d3e0d5025c027899a642ed3d.png";